import React from "react";
import "../css/QuickMenuDialog.css";
import { WEB_LINK } from "utils/strings";
import headerAppIcon from "../../assets/images/header-sabehub-app-icon.svg";
import foundryAppIcon from "../../assets/images/become-member-the-foundry-logo.svg";
import appTextLogo from "../../assets/images/quick-menu-app-text-logo.svg";
import infoIcon from "../../assets/images/become-member-purple-info-icon.svg";
import foundryInfoIcon from "../../assets/images/become-member-info-icon.svg";
import BottomSheet from "./BottomSheet";
import { useNavigate } from "react-router-dom";
import ROUTE_PATHS from "utils/routePaths";

interface BecomeMemberPopupProps {
  open: boolean;
  onClose: () => void;
}

const BecomeMemberPopup: React.FC<BecomeMemberPopupProps> = ({
  open,
  onClose,
}) => {
  const navigate = useNavigate();

  const handleSabehubEcosystemClick = () => {
    navigate(ROUTE_PATHS.WSM_WEB_LINK_DETAIL, {
      state: {
        anyData: {
          title: "The Foundry",
          url: WEB_LINK.BECOME_MEMBER,
        },
      },
    });
    onClose();
  };

  const handleExecutionSpaceClick = () => {
    navigate(ROUTE_PATHS.WSM_WEB_LINK_DETAIL, {
      state: {
        anyData: {
          title: "Execution Space Membership",
          url: WEB_LINK.EXECUTION_SPACE_LINK,
        },
      },
    });
    onClose();
  };

  return (
    <BottomSheet
      open={open}
      onClose={onClose}
      height="90dvh"
    >
      <div className="quick-menu-dialog-container">
        <div className="quick-menu-header-container">
          <div className="quick-menu-header-text-container">
            <span>
              Become <span style={{ color: "white" }}>a member</span>
            </span>
          </div>
          <div className="quick-menu-header-container-divider"></div>
          <div className="quick-menu-header-button-container">
            <div
              className="quick-menu-header-container-button"
              onClick={onClose}
            >
              ✕
            </div>
          </div>
        </div>

        <div className="quick-menu-second-step-header-container">
          <span>
            Two Ways In.{" "}
            <span style={{ color: "#C1F700" }}>Pick the Path that fits.</span>
          </span>
        </div>

        <div className="quick-menu-content-container">
          <>
            <div
              className="become-member-card-container purple-shadow"
              onClick={handleExecutionSpaceClick}
            >
              <div className="header-conatiner">
                <img src={headerAppIcon} alt="score-card-icon" />
                <span>Execution Space Membership</span>
              </div>
              <span className="card-title">
                Quiet, Focused Zones For{" "}
                <span style={{ color: "#9B5DE5" }}>
                  Deep Work, Calls, And Real Output.
                </span>
              </span>
              <span className="card-detail">
                Our Create, Innovate & Communicate Spaces — The Right
                Environment For Thinking, Executing, And Aligning With Your
                Team, All Under One Roof.
              </span>
              <div className="footer-container">
                <img src={infoIcon} alt="info-icon" />
                <span>Choose from 3 plans starting from ₹5000</span>
              </div>
            </div>
            <div
              className="become-member-card-container orange-shadow"
              onClick={handleSabehubEcosystemClick}
            >
              <div className="header-conatiner orange">
                <img src={foundryAppIcon} alt="score-card-icon" />
                <span>The Foundry</span>
              </div>
              <span className="card-title">
                Everything in Execution Space — Plus A Private Room Of
                <span style={{ color: "#ff6b35" }}> Serious Founders.</span>
              </span>
              <span className="card-detail">
                Masterminds, Mentorship, Founder Dinners, Tactical Workshops &
                An Annual Retreat. Not Coworking. Not Networking.{" "}
                <span style={{ color: "#ff6b35" }}>A Better Way To Build.</span>
              </span>
              <div className="footer-container">
                <img src={foundryInfoIcon} alt="info-icon" />
                <span>Membership Starts From ₹30,000. Only 50 Seats</span>
              </div>
            </div>
          </>
        </div>
        <div className="quick-menu-footer-container">
          <span>Powered By</span>
          <div className="sub-conatiner">
            <img
              src={headerAppIcon}
              alt="quick-menu-app-logo"
              className="footer-app-icon"
            />
            <img src={appTextLogo} alt="quick-menu-app-text-logo" />
          </div>
        </div>
      </div>
    </BottomSheet>
  );
};

export default BecomeMemberPopup;
